import isEmpty from "lodash/isEmpty";
import { sanitizeColumnsDisplay } from "PFApp/booking/parts/overview/booking_module_calendar/side_panel_header/actions_bar/table_properties/helpers/columns_display";
import { useEngagementsColumns } from "PFApp/booking/parts/overview/side_panel_row/columns/use_engagements_columns";
import { useProfilesColumns } from "PFApp/booking/parts/overview/side_panel_row/columns/use_profiles_columns";
import { useRolesColumns } from "PFApp/booking/parts/overview/side_panel_row/columns/use_roles_columns";
import { ColumnsType, useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { stringify } from "PFCore/helpers/use_deterministic_stringify";
import { TableColumn } from "PFTypes";
import { useEffect } from "react";

export const useRowsColumns = () => {
  const calendarRoot = useCalendarRoot();
  const columns = useBookingModuleStore((state) => state[calendarRoot].columns);
  const workforceProfilesActions = useBookingModuleStore(
    (state) => state.actions[CalendarRoot.WorkforceProfiles]
  );
  const projectsRolesActions = useBookingModuleStore((state) => state.actions[CalendarRoot.ProjectsRoles]);
  const projectsEngagementsActions = useBookingModuleStore(
    (state) => state.actions[CalendarRoot.ProjectsEngagements]
  );

  const { availableColumns: availableProfilesColumns } = useProfilesColumns();
  const { availableColumns: availableEngagementsColumns } = useEngagementsColumns();
  const { availableColumns: availableRolesColumns } = useRolesColumns();

  const updateColumnsDisplayToMatchAvailable = (
    columnsType: ColumnsType,
    availableColumns: TableColumn[]
  ) => {
    const sanitizedDisplay = sanitizeColumnsDisplay(columns[columnsType], availableColumns);
    if (sanitizedDisplay) {
      workforceProfilesActions.setColumnsDisplay(columnsType, sanitizedDisplay);
      projectsRolesActions.setColumnsDisplay(columnsType, sanitizedDisplay);
      projectsEngagementsActions.setColumnsDisplay(columnsType, sanitizedDisplay);
    }
  };

  const availableProfileColumnNames = stringify(availableProfilesColumns.map(({ name }) => name));
  const availableEngagementsColumnNames = stringify(availableEngagementsColumns.map(({ name }) => name));
  const availableRolesColumnNames = stringify(availableRolesColumns.map(({ name }) => name));

  useEffect(() => {
    workforceProfilesActions.setAvailableColumns("profiles", availableProfilesColumns);

    const rootColumn = availableProfilesColumns.find(({ name }) => name === "root");
    rootColumn && projectsRolesActions.setAvailableColumns("profiles", [rootColumn]);
    rootColumn && projectsEngagementsActions.setAvailableColumns("profiles", [rootColumn]);

    if (!isEmpty(availableProfilesColumns)) {
      updateColumnsDisplayToMatchAvailable("profiles", availableProfilesColumns);
    }
  }, [availableProfileColumnNames]);

  useEffect(() => {
    projectsRolesActions.setAvailableColumns("engagements", availableEngagementsColumns);
    projectsEngagementsActions.setAvailableColumns("engagements", availableEngagementsColumns);

    const rootColumn = availableEngagementsColumns.find(({ name }) => name === "root");
    rootColumn && workforceProfilesActions.setAvailableColumns("engagements", [rootColumn]);

    if (!isEmpty(availableEngagementsColumns)) {
      updateColumnsDisplayToMatchAvailable("engagements", availableEngagementsColumns);
    }
  }, [availableEngagementsColumnNames]);

  useEffect(() => {
    projectsRolesActions.setAvailableColumns("roles", availableRolesColumns);
    projectsEngagementsActions.setAvailableColumns("roles", availableRolesColumns);

    const rootColumn = availableRolesColumns.find(({ name }) => name === "root");
    rootColumn && workforceProfilesActions.setAvailableColumns("roles", [rootColumn]);

    if (!isEmpty(availableRolesColumns)) {
      updateColumnsDisplayToMatchAvailable("roles", availableRolesColumns);
    }
  }, [availableRolesColumnNames]);
};
